var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M12.79,9.22H9.11l.35,18.91h3.68Zm8.54,21.07v.05a.21.21,0,0,1-.21.2H6.89a.21.21,0,0,1-.22-.2L6,9.22H2.27L3,30.37A3.79,3.79,0,0,0,6.89,34H21.12A3.79,3.79,0,0,0,25,30.37l.72-21.15H22.05ZM15.21,9.22l-.35,18.91h3.68L18.9,9.22Zm6.24-5.57C20.39,1.31,17.77,0,14,0S7.61,1.31,6.55,3.65H0V7.11H28V3.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.2eaf756eadb013b4597d3c576dfcaf0d.svg";
export { ForwardRef as ReactComponent };